"use strict";
import a from "./index.es155.js";
function i(e, u, t) {
  const o = t.config.validateStatus;
  !t.status || !o || o(t.status) ? e(t) : u(new a(
    "Request failed with status code " + t.status,
    [a.ERR_BAD_REQUEST, a.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
export {
  i as default
};
//# sourceMappingURL=index.es354.js.map
